// src/components/Atelier3/Activite1/GuideModal.js
import React from 'react';
import { motion } from 'framer-motion';
import { X, Users, Target, Shield, AlertTriangle, HelpCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const GuideModal = ({ isOpen, onClose, className = "" }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const steps = [
    {
      title: t('workshop3.activity1.guide.step1Title'),
      description: t('workshop3.activity1.guide.step1Description'),
      icon: <Users size={20} className="text-blue-500" />
    },
    {
      title: t('workshop3.activity1.guide.step2Title'),
      description: t('workshop3.activity1.guide.step2Description'),
      icon: <Target size={20} className="text-orange-500" />
    },
    {
      title: t('workshop3.activity1.guide.step3Title'),
      description: t('workshop3.activity1.guide.step3Description'),
      icon: <Shield size={20} className="text-green-500" />
    },
    {
      title: t('workshop3.activity1.guide.step4Title'),
      description: t('workshop3.activity1.guide.step4Description'),
      icon: <AlertTriangle size={20} className="text-red-500" />
    }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3 }}
      className={`bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden mb-6 ${className}`}
    >
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-indigo-700 p-6 flex justify-between items-center">
        <div className="flex items-center text-white">
          <HelpCircle size={24} className="mr-3" />
          <h2 className="text-xl font-bold">{t('workshop3.activity1.guide.title')}</h2>
        </div>
        <button
          onClick={onClose}
          className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-1 transition-colors"
          aria-label={t('common.close', 'Close')}
        >
          <X size={24} />
        </button>
      </div>

      {/* Content */}
      <div className="p-6">
        <p className="text-gray-600 mb-6">
          {t('workshop3.activity1.guide.description')}
        </p>

        <h3 className="text-lg font-semibold text-gray-900 mb-4">{t('workshop3.activity1.guide.stepsToFollow')}</h3>

        <div className="space-y-8">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="flex"
            >
              <div className="flex-shrink-0 mr-4">
                <div className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-100 text-blue-600 font-bold">
                  {index + 1}
                </div>
              </div>
              <div className="flex-1">
                <div className="flex items-center mb-2">
                  {step.icon}
                  <h3 className="text-lg font-semibold text-gray-800 ml-2">{step.title}</h3>
                </div>
                <p className="text-gray-600">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default GuideModal;
